export default String.raw`
{% if page.Language == 'de' -%}
    {% assign dateFormat = 'dd.MM.yyyy' -%}
{% elseif page.Language == 'fr' or page.Language == 'en' -%}
    {% assign dateFormat = 'dd\/MM\/yyyy' -%}
{% else -%}
    {% assign dateFormat = 'yyyy-MM-dd' -%}
{% endif -%}
`